import { NgClass } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import {
  InputChangeEventDetail,
  IonCol,
  IonInput,
  IonRow,
} from '@ionic/angular/standalone';
import { IMAGE_SRC } from 'src/app/components/shared/shared-constants';
import { DISP_CONSTANTS } from './header-search.constants';

@Component({
  selector: 'app-header-search',
  templateUrl: './header-search.component.html',
  styleUrls: ['./header-search.component.scss'],
  imports: [IonInput, IonCol, IonRow, NgClass],
  standalone: true,
})
export class HeaderSearchComponent {
  @Input() isDisabled = false;
  @Output() emitTextChange = new EventEmitter();
  @Output() emitClearChange = new EventEmitter();

  @ViewChild(IonInput) input!: IonInput;

  readonly IMAGES = IMAGE_SRC;
  readonly DISP_CONSTANTS = DISP_CONSTANTS;

  showCancelButton = false;

  clearSearch() {
    this.input.value = '';
    this.emitClearChange.emit();
  }

  sendTextChange($event: CustomEvent<InputChangeEventDetail>) {
    this.emitTextChange.emit($event);
  }
}
